module.exports = __webpack_public_path__ + "static/img/fuermei.7a2c2ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/fuermei.png
// module id = gCtb
// module chunks = 1